// 检查当前缓存的id情况
export function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
        deviceId = 'device_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
}

// utils/zoomDetector.js
export function getZoomLevel() {
  // 首选方法：使用 devicePixelRatio
  // if (window.devicePixelRatio !== undefined) {
  //   return window.devicePixelRatio;
  // }
  
  // 备选方法：计算窗口比例
  try {
    if (window.outerWidth && window.innerWidth) {
      // return window.outerWidth / window.innerWidth;
      return window.innerWidth / window.outerWidth;
    }
  } catch (e) {
    console.warn("Zoom detection fallback failed:", e);
  }
  
  return 1; // 默认无缩放
}